import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import router from './router'


// router.afterEach(() => {
// 	window.scrollTo(0, 0);
// 	document.body.scrollTop = 0
// 	document.documentElement.scrollTop = 0
// 	window.pageYOffset = 0
// });


new Vue({
	router, //子组件可以用this.$router来访问路由
	render: h => h(App),
}).$mount('#app')
